<template>
  <div class="userDataDeletion">
    <p>
    User must do by following processes to remove user data. <br/>
    1) Move to 'Profile' below menu tab<br/>
    2) Open menu on user profile page located top-left<br/>
    3) Move to menu [Settings]-[Remove user data]
    </p>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

export default {
  name: 'UserDataDeletion',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

background-color:#262626;
p {
  font-size: 20px;
}
a {
  color: #42b983;
}
span {
  vertical-align: middle;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/UserDataDeletion.vue